import http from '@/plugins/axios/axios';

export default class ArquivoFolhaDominioService {

    salvar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-dominio/salvar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-dominio/listar', requisicao);
    } 
    
    exportarArquivoFolha(requisicao) {       
        return http.post('/api/documento/arquivo-folha-dominio/folha-pag', requisicao, {responseType: 'blob'});
    } 
}